import React, { useMemo } from 'react';
import './ContextualAnalysisModal.scss';
import Modal from 'react-modal';
import { BaseWidget } from 'models/WidgetModel';
import SessionExplorerContainerV2 from 'components/SessionExplorerContainer/SessionExplorerContainerV2';
import { transformRowData, createFieldMap } from 'helpers/dataGridTransformation';
import { ColumnDefinition } from 'models/DataGridTypes';

interface CategoryMetricsModalProps extends BaseWidget {
  modalOpen: boolean;
  onRequestClose: () => void;
}

const getSentimentDistrbution = (sentimentDistribution: string | any) => {
  if (typeof sentimentDistribution === 'string') {
    const parts = sentimentDistribution.split(';').map((part) => parseFloat(part));
    return {
      negative: parts[0] || 0,
      neutral: parts[1] || 0,
      positive: parts[2] || 0,
    };
  } else if (typeof sentimentDistribution === 'object') {
    return sentimentDistribution;
  }
};

const ContextualAnalysisModal: React.FC<CategoryMetricsModalProps> = ({
  secondaryCategory,
  onChangeCategory,
  response: bundledData,
  options,
  modalOpen,
  onRequestClose,
  ...props
}) => {
  // Transform secondaryCategory using the column mapping from bundledData
  const transformedCategory = useMemo(() => {
    if (!secondaryCategory || !bundledData?.data?.columns) {
      return null;
    }

    const fieldMap = createFieldMap(bundledData.data.columns);
    return transformRowData(secondaryCategory, fieldMap);
  }, [secondaryCategory, bundledData?.data?.columns]);

  props.colors = [];

  const closeModal = () => {
    onRequestClose();
  };

  return (
    <Modal
      isOpen={modalOpen}
      onRequestClose={closeModal}
      className={'pck_session-modal'}
      shouldCloseOnOverlayClick={true}
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
        },
        content: {
          width: '95%',
          maxHeight: '95%',
          boxSizing: 'border-box',
          overflow: 'hidden',
          overflowY: 'scroll',
        },
      }}
    >
      <SessionExplorerContainerV2
        onRequestClose={closeModal}
        bundledData={bundledData}
        onChangeCategory={onChangeCategory}
        response={{}}
        options={options}
        context={transformedCategory}
        {...props}
      />
    </Modal>
  );
};

export default ContextualAnalysisModal;
